import { render, staticRenderFns } from "./WelfareTrainingAdd.vue?vue&type=template&id=4600d306&scoped=true"
import script from "./WelfareTrainingAdd.vue?vue&type=script&lang=js"
export * from "./WelfareTrainingAdd.vue?vue&type=script&lang=js"
import style0 from "./WelfareTrainingAdd.vue?vue&type=style&index=0&id=4600d306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4600d306",
  null
  
)

export default component.exports